module.exports = __webpack_public_path__ + "img/gjfjg_banner_img.7cb2c0d5.png";